import React, { Component } from "react";
import {
  Grid, Segment, Divider, List,
  Button, Modal, Input, Icon, Checkbox,
  Dropdown, Header, Form, Popup
} from "semantic-ui-react";
import { Network, DataSet } from "vis";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";
import C2S from "canvas2svg-visjs";

const NETWORK_ID = "network";
const ADD_DEVICE_MODAL_OK_ID = "add-device-button";
const ADD_DEVICE_MODAL_CLOSE_ID = "close-add-device-modal-button";
const ADD_DEVICE_TAG_ID = "add-device-tag";
const ADD_SCOPE_IP_ID = "add-scope-ip-id";
const EDIT_DEVICE_TAG_ID = "edit-tag";
const EDIT_DEVICE_MODAL_CLOSE_ID = "close-edit-device-modal-button";
const EDIT_DEVICE_MODAL_OK_ID = "edit-device-button";
const EDIT_LL_DEVICE_MODAL_CLOSE_ID = "close-edit-ll-device-modal-button";
const EDIT_LL_DEVICE_MODAL_OK_ID = "edit-ll-device-button";

const DP_STANDARD_COLOR = "#6435c9";
const DP_HAZARDOUS_COLOR = "#0000FF";
const PA_STANDARD_COLOR = "#f2711c";
const PA_HAZARDOUS_COLOR = "#2185d0";
const OPTIC_FIBER_COLOR = "#000000";

const MASTER_DEVICE_TYPE = "master";
const SLAVE_DEVICE_TYPE = "slave";
const SLAVE_PA_DEVICE_TYPE = "slave-pa";
const REPEATER_DEVICE_TYPE = "repeater";
const HUB_DEVICE_TYPE = "hub";
const JB_DEVICE_TYPE = "jb";
const COUPLER_PROXY_DEVICE_TYPE = "coupler-proxy";
const FIBER_LINK_DEVICE_TYPE = "fiber-link";
const ACTIVE_TERMINATION_DEVICE_TYPE = "active-termination";
const TS_MONITOR_DEVICE_TYPE = "ts-monitor";
const TS_SCOPE_DP_TYPE = "ts-scope-dp";
const TS_SCOPE_PA_TYPE = "ts-scope-pa";
const OLD_TS_SCOPE_DP_TYPE = "an-rm-dp";
const OLD_TS_SCOPE_PA_TYPE = "an-rm-pa";
const MPI_DEVICE_TYPE = "mpi";

const FETCH_TS_SCOPE_TIMEOUT = 1000;
const GRID_SIZE = 140;

const UtilsInstance = new Utils();

// List of devices and connections with problems
// They are marked to be automatically removed from saved devices and saved connections
var devicesToDeleteFromSavedDevices;
var connectionsToDeleteFromSavedConnections;

// Vis.js Network
var nodes = new DataSet();
var edges = new DataSet();
var networkOptions = {};
var network;

// Export Image Canvas options
C2S.prototype.circle = CanvasRenderingContext2D.prototype.circle;
C2S.prototype.square = CanvasRenderingContext2D.prototype.square;
C2S.prototype.triangle = CanvasRenderingContext2D.prototype.triangle;
C2S.prototype.triangleDown = CanvasRenderingContext2D.prototype.triangleDown;
C2S.prototype.star = CanvasRenderingContext2D.prototype.star;
C2S.prototype.diamond = CanvasRenderingContext2D.prototype.diamond;
C2S.prototype.roundRect = CanvasRenderingContext2D.prototype.roundRect;
C2S.prototype.ellipse_vis = CanvasRenderingContext2D.prototype.ellipse_vis;
C2S.prototype.database = CanvasRenderingContext2D.prototype.database;
C2S.prototype.arrowEndpoint = CanvasRenderingContext2D.prototype.arrowEndpoint;
C2S.prototype.circleEndpoint = CanvasRenderingContext2D.prototype.circleEndpoint;
C2S.prototype.dashedLine = CanvasRenderingContext2D.prototype.dashedLine;

var connectionsOptions = [
  {
    key: Constants.PROFIBUS_DP_COLOR_TYPE,
    text: "PROFIBUS DP",
    value: Constants.PROFIBUS_DP_COLOR_TYPE,
    label: { color: "violet" }
  },
  {
    key: Constants.PROFIBUS_DP_IS_COLOR_TYPE,
    text: "PROFIBUS DP-IS",
    value: Constants.PROFIBUS_DP_IS_COLOR_TYPE,
    label: { color: "olive" }
  },
  {
    key: Constants.PROFIBUS_MBP_PA_NON_HAZ_COLOR_TYPE,
    text: "PROFIBUS-MBP (PA)",
    value: Constants.PROFIBUS_MBP_PA_NON_HAZ_COLOR_TYPE,
    label: { color: "orange" }

  },
  {
    key: Constants.PROFIBUS_MBP_PA_HAZ_COLOR_TYPE,
    text: "PROFIBUS-MBP (PA)",
    value: Constants.PROFIBUS_MBP_PA_HAZ_COLOR_TYPE,
    label: { color: "blue" }
  },
  {
    key: Constants.PROFIBUS_OPTIC_FIBER_COLOR_TYPE,
    text: Strings.OPTIC_FIBER,
    value: Constants.PROFIBUS_OPTIC_FIBER_COLOR_TYPE,
    label: { color: "black" }
  }
];

var typeOptions = [
  {
    key: REPEATER_DEVICE_TYPE,
    text: Strings.REPEATER_NAME,
    value: REPEATER_DEVICE_TYPE
  },
  {
    key: HUB_DEVICE_TYPE,
    text: Strings.HUB_NAME,
    value: HUB_DEVICE_TYPE
  },
  {
    key: JB_DEVICE_TYPE,
    text: Strings.JB_NAME,
    value: JB_DEVICE_TYPE
  },
  {
    key: COUPLER_PROXY_DEVICE_TYPE,
    text: Strings.COUPLER_PROXY_NAME,
    value: COUPLER_PROXY_DEVICE_TYPE
  },
  {
    key: FIBER_LINK_DEVICE_TYPE,
    text: Strings.FIBER_LINK_NAME,
    value: FIBER_LINK_DEVICE_TYPE
  },
  {
    key: ACTIVE_TERMINATION_DEVICE_TYPE,
    text: Strings.ACTIVE_TERMINATION_NAME,
    value: ACTIVE_TERMINATION_DEVICE_TYPE
  },
  {
    key: TS_MONITOR_DEVICE_TYPE,
    text: Strings.TS_MONITOR_NAME,
    value: TS_MONITOR_DEVICE_TYPE
  },
  {
    key: TS_SCOPE_DP_TYPE,
    text: Strings.TS_SCOPE_DP_NAME,
    value: TS_SCOPE_DP_TYPE
  },
  {
    key: TS_SCOPE_PA_TYPE,
    text: Strings.TS_SCOPE_PA_NAME,
    value: TS_SCOPE_PA_TYPE
  }
];

var liveListTypeOptions = [
  {
    key: SLAVE_DEVICE_TYPE,
    text: Strings.SLAVE_NAME,
    value: SLAVE_DEVICE_TYPE
  },
  {
    key: SLAVE_PA_DEVICE_TYPE,
    text: Strings.SLAVE_PA_NAME,
    value: SLAVE_PA_DEVICE_TYPE
  },
  {
    key: REPEATER_DEVICE_TYPE,
    text: Strings.REPEATER_NAME,
    value: REPEATER_DEVICE_TYPE
  },
  {
    key: COUPLER_PROXY_DEVICE_TYPE,
    text: Strings.COUPLER_PROXY_NAME,
    value: COUPLER_PROXY_DEVICE_TYPE
  }
];

var liveListDeviceTypeMap = {};

export class GraphicTopology extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      devices: [],
      isAddDeviceModalOpen: false,
      isAddConnectionModalOpen: false,
      isEditDeviceModalOpen: false,
      isEditLiveListDeviceModalOpen: false,
      isDeletePositioningModalOpen: false,
      isDefaultConnectionTypeModalOpen: false,
      defaultConnectionColorType: Constants.PROFIBUS_DP_COLOR_TYPE,
      connectionColorType: "",
      deviceType: "",
      savedDevices: [],
      connections: [],
      formInput: "",
      addDeviceTagInputValue: "",
      editDeviceTagInputValue: "",
      addDeviceAddress: "",
      addDeviceCheckboxValue: "m",
      baudRate: -1,
      addScopeIpInputValue: ""
    };
  }

  snapToGrid = (value) => Math.round(value / GRID_SIZE) * GRID_SIZE;

  snapAllNodesToGrid = () => {
    if (!network) return;

    network.storePositions();

    const updates = [];
    nodes.forEach((node) => {
      updates.push({
        id: node.id,
        x: this.snapToGrid(node.x),
        y: this.snapToGrid(node.y)
      });
    });

    if (updates.length > 0) {
      nodes.update(updates);
    }
  };

  // --- Fetching -----
  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "trafficStatistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ baudRate: data.baudRate }, () => {
        // If the baud rate is equal to 0, show the addDeviceSegment
        if (this.state.baudRate === 0) {
          document.getElementById("addDeviceSegment").style.display = "block";
          document.getElementById("addDeviceSegment").style.visibility = "visible";
        }
        // If it is not 0, hide the addDeviceSegment
        else {
          document.getElementById("addDeviceSegment").style.display = "none";
          document.getElementById("addDeviceSegment").style.visibility = "hidden";
        }
      }));

    // Retrieve the live list information
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        devices: data.sort(UtilsInstance.sortBy(
          "address",
          false,
          parseInt))
      }, () => {
        // Then try to retrieve saved devices information
        fetch(Constants.REQUEST_IP_ADDRESS + "savedDevices", { mode: "cors" })
          .then(res => res.json())
          .then(data => this.setState({ savedDevices: data }, () => {
            // Finally try to retrieve saved connections information
            fetch(Constants.REQUEST_IP_ADDRESS + "savedConnections", { mode: "cors" })
              .then(res => res.json())
              .then(data => this.setState({ connections: data }, () => {
                // If we couldn't retrieve saved information, we just load information from the live list
                if (this.state.savedDevices.length === 0 && this.state.connections.length === 0) {
                  this.createLiveListDeviceTypeMap(false);
                  this.createNodes(false);
                  this.createNetwork(true);
                }
                else {
                  this.createLiveListDeviceTypeMap(true);
                  this.createNodes(true);
                  this.createConnections();

                  // If there were any devices with problems, remove them and their connections from the database
                  if (devicesToDeleteFromSavedDevices.devicesToDelete.length > 0) {

                    let deviceListAlert = Strings.POSITIONING_CONFLICT_1;

                    for (let i = 0; i < devicesToDeleteFromSavedDevices.devicesToDelete.length; i++) {
                      if (i === (devicesToDeleteFromSavedDevices.devicesToDelete.length - 1)) {
                        deviceListAlert = deviceListAlert.concat(" " + devicesToDeleteFromSavedDevices.devicesToDelete[i].id + ".");
                      }
                      else {
                        deviceListAlert = deviceListAlert.concat(" " + devicesToDeleteFromSavedDevices.devicesToDelete[i].id + ",");
                      }
                    }

                    deviceListAlert = deviceListAlert.concat(Strings.POSITIONING_CONFLICT_2);

                    alert(deviceListAlert);

                    this.removeDevicesWithProblemsFromSavedDevicesAndConnections();
                  }
                  else {
                    this.createNetwork(false);
                  }
                }
              }));
          }));
      }));
  }

  refreshLiveListAndScopeDeviceStatus = () => {
    // First retrieve the baud rate to know if the add/remove device segment
    // should be shown
    fetch(Constants.REQUEST_IP_ADDRESS + "trafficStatistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ baudRate: data.baudRate }, () => {

        if (this.state.baudRate === 0) {
          document.getElementById("addDeviceSegment").style.display = "block";
          document.getElementById("addDeviceSegment").style.visibility = "visible";
        }
        else {
          document.getElementById("addDeviceSegment").style.display = "none";
          document.getElementById("addDeviceSegment").style.visibility = "hidden";
        }

        fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
          .then(res => res.json())
          .then(data => this.setState({
            devices: data.sort(UtilsInstance.sortBy(
              "address",
              false,
              parseInt))
          }, () => {
            // Try to update all node images, title and label based on the new live list status info.
            nodes.forEach(async (node) => {
              // If the node is a TS Scope, get the node title information
              if (typeof (node.id) === "string" && UtilsInstance.validateIPAddress(node.id)) {
                if (node.label.includes("TS Scope DP")) {
                  let scopeDPTag = await fetch("http://" + node.id + ":5000/tag", { mode: "cors" })
                    .then(res => res.json())
                    .then(data => data.tag);

                  let scopeDPMonitor = await fetch("http://" + node.id + ":5000/monitorIP", { mode: "cors" })
                    .then(res => res.json())
                    .then(data => data.monitorAddr);

                  nodes.update({
                    id: node.id,
                    title: this.createScopeDPNodeTitle(scopeDPTag, scopeDPMonitor)
                  });
                }
                else {
                  let channelTagsAndNotes = await fetch("http://" + node.id + ":5000/getChannelTagsAndNotes", { mode: "cors" })
                    .then(res => res.json())
                    .then(data => data);

                  nodes.update({
                    id: node.id,
                    title: this.createScopePANodeTitle(channelTagsAndNotes)
                  });
                }
              }
              else {
                for (let i = 0; i < this.state.devices.length; i++) {
                  if (node.id === this.state.devices[i].address) {

                    let label = node.label;
                    label = node.label.substr(0, node.label.indexOf("\n"));
                    label = label + "\n" + this.getNodeTag(this.state.devices[i].tag);
                    console.log(label);

                    nodes.update({
                      id: node.id,
                      label: label,
                      image: this.getDeviceImagePathBasedOnDeviceTypeAndStatus(
                        liveListDeviceTypeMap[node.id].devType,
                        this.state.devices[i]
                      ),
                      title: this.createNodeTitle(this.state.devices[i])
                    });
                    break;
                  }
                }
              }
            });

            // If a new node has been found, add it 
            for (let i = 0; i < this.state.devices.length; i++) {

              if (nodes.get(this.state.devices[i].address) === null) {

                let imagePath = this.getDeviceImagePath(this.state.devices[i]);
                let tag = this.getNodeTag(this.state.devices[i].tag);

                // If the device is a master  
                if (this.state.devices[i].status === Constants.MASTER
                  || this.state.devices[i].status === Constants.MASTER_FAULT) {
                  nodes.add({
                    id: this.state.devices[i].address,
                    label: Strings.MASTER_NAME + " #" + this.state.devices[i].address + "\n" + tag,
                    shape: "image",
                    image: imagePath,
                    shapeProperties: {
                      useImageSize: false
                    },
                    title: this.createNodeTitle(this.state.devices[i])
                  });
                }
                else if (this.state.devices[i].status === Constants.MPI
                  || this.state.devices[i].status === Constants.MPI_FAULT) {
                  nodes.add({
                    id: this.state.devices[i].address,
                    label: Strings.MPI_NAME + " #" + this.state.devices[i].address + "\n" + tag,
                    shape: "image",
                    image: imagePath,
                    shapeProperties: {
                      useImageSize: false
                    },
                    title: this.createNodeTitle(this.state.devices[i])
                  });
                }
                else {
                  nodes.add({
                    id: this.state.devices[i].address,
                    label: Strings.SLAVE_NAME + " #" + this.state.devices[i].address + "\n" + tag,
                    shape: "image",
                    image: imagePath,
                    shapeProperties: {
                      useImageSize: false
                    },
                    title: this.createNodeTitle(this.state.devices[i])
                  });
                }

                this.addDeviceTypeToMap(this.state.devices[i]);

              }
            }
          }));
      }));
  }

  // ----------------- Device Type Map functions -----------------
  createLiveListDeviceTypeMap = (isPositionSaved) => {
    if (!isPositionSaved) {
      for (let i = 0; i < this.state.devices.length; i++) {
        liveListDeviceTypeMap[this.state.devices[i].address] = {
          devType: this.getDeviceTypeFromLiveListStatus(this.state.devices[i].status)
        };
      }
    }
    else {
      for (let i = 0; i < this.state.savedDevices.length; i++) {
        liveListDeviceTypeMap[this.state.savedDevices[i].id] = {
          devType: this.state.savedDevices[i].deviceType
        };
      }
    }
  }

  handleEditDefaultConnectionTypeClick = () => {
    this.setState({
      isDefaultConnectionTypeModalOpen: true,
      connectionColorType: this.state.defaultConnectionColorType
    });
  }

  closeDefaultConnectionTypeModal = () => {
    this.setState({
      isDefaultConnectionTypeModalOpen: false,
      connectionColorType: ""
    });
  }

  saveDefaultConnectionType = () => {
    const connectionType =
      this.state.connectionColorType ||
      this.state.defaultConnectionColorType ||
      Constants.PROFIBUS_DP_COLOR_TYPE;

    this.setState({
      defaultConnectionColorType: connectionType,
      isDefaultConnectionTypeModalOpen: false,
      connectionColorType: ""
    });
  }

  addDeviceTypeToMap = (device) => {
    liveListDeviceTypeMap[device.address] = {
      devType: this.getDeviceTypeFromLiveListStatus(device.status)
    };
  }

  updateLiveListDeviceTypeMap = (deviceAddress, deviceType) => {
    // Save the choosen device type to the map
    liveListDeviceTypeMap[deviceAddress] = {
      devType: deviceType
    };
  }

  getDeviceTypeFromMap = (deviceAddress) => {
    return liveListDeviceTypeMap[deviceAddress].devType;
  }

  getDeviceTypeFromLiveListStatus = (status) => {
    if (status === Constants.MASTER || status === Constants.MASTER_FAULT) {
      return MASTER_DEVICE_TYPE;
    }
    else if (status === Constants.MPI || status === Constants.MPI_FAULT) {
      return MPI_DEVICE_TYPE;
    }
    else {
      return SLAVE_DEVICE_TYPE;
    }
  }

  // ----------------- Network manipulation ----------------
  createNodeTitle = (device) => {
    let tag = "";
    let model = "";
    let nodeTitle = "";

    if (device.tag !== null) {
      tag = device.tag;
    }

    if (device.model !== null) {
      model = device.model;
    }

    if (device.lastEvent !== null && device.lastEvent.length === 1) {
      nodeTitle = "<p> TAG: " + tag
        + "<br />Modelo: " + model
        + "<br />Último evento: " + device.lastEvent[0] + "</p >";
    }
    else if (device.lastEvent !== null && device.lastEvent.length > 1) {
      nodeTitle = "<p> TAG: " + tag
        + "<br />Modelo: " + model
        + "<br />Último evento: <br> <ul>";

      for (let i = 0; i < device.lastEvent.length; i++) {
        nodeTitle = nodeTitle + "<li>" + device.lastEvent[i] + "</li>";
      }

      nodeTitle = nodeTitle + "</ul>";
    }
    else {
      nodeTitle = "<p> TAG: " + tag
        + "<br />Modelo: " + model
        + "<br />Último evento:</p >";
    }

    return nodeTitle;
  }

  createScopePANodeTitle = (channelTagsAndNotes) => {
    let nodeTitle = "";

    for (let i = 0; i < channelTagsAndNotes.length; i++) {
      nodeTitle += "<p><b> Canal: " + channelTagsAndNotes[i].channel + "</b></p>";
      nodeTitle += "<ul>";
      nodeTitle += "<li> <b>Tag:</b> " + channelTagsAndNotes[i].tag + "</li>";
      nodeTitle += "<li> <b>Observação:</b> " + channelTagsAndNotes[i].note + "</li>";
      nodeTitle += "</ul>";
    }

    return nodeTitle;
  }

  createScopeDPNodeTitle = (scopeDPTag, scopeDPMonitor) => {
    let nodeTitle = "";

    nodeTitle = "<p> TAG: " + scopeDPTag + "<br />" + Strings.IP_ASSOCIATED_MONITOR + scopeDPMonitor + "</p >";

    return nodeTitle;
  }

  getNodeTag = (tag) => {
    if (tag !== undefined && tag !== null && tag !== "") {
      return tag;
    }
    else {
      return "";
    }
  }

  createNodes = (isPositionSaved) => {
    nodes = new DataSet();

    if (!isPositionSaved) {
      for (let i = 0; i < this.state.devices.length; i++) {
        let imagePath = this.getDeviceImagePath(this.state.devices[i]);
        // If the device is a master  
        if (this.state.devices[i].status === Constants.MASTER
          || this.state.devices[i].status === Constants.MASTER_FAULT) {
          nodes.add({
            id: this.state.devices[i].address,
            label: Strings.MASTER_NAME + " #" + this.state.devices[i].address
              + "\n" + this.getNodeTag(this.state.devices[i].tag),
            shape: "image",
            image: imagePath,
            shapeProperties: {
              useImageSize: false
            },
            title: this.createNodeTitle(this.state.devices[i])
          });
        }
        else if (this.state.devices[i].status === Constants.MPI
          || this.state.devices[i].status === Constants.MPI_FAULT) {
          nodes.add({
            id: this.state.devices[i].address,
            label: Strings.MPI_NAME + " #" + this.state.devices[i].address
              + "\n" + this.getNodeTag(this.state.devices[i].tag),
            shape: "image",
            image: imagePath,
            shapeProperties: {
              useImageSize: false
            },
            title: this.createNodeTitle(this.state.devices[i])
          });
        }
        else {
          nodes.add({
            id: this.state.devices[i].address,
            label: Strings.SLAVE_NAME + " #" + this.state.devices[i].address
              + "\n" + this.getNodeTag(this.state.devices[i].tag),
            shape: "image",
            image: imagePath,
            shapeProperties: {
              useImageSize: false
            },
            title: this.createNodeTitle(this.state.devices[i])
          });
        }
      }
    }
    else {
      for (let i = 0; i < this.state.savedDevices.length; i++) {

        let deviceStatus = this.getDeviceStatus(this.state.savedDevices[i].id);
        let device = this.getDeviceFromLiveList(this.state.savedDevices[i].id);
        let deviceImage = "";

        if (deviceStatus !== "") {
          deviceImage = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(
            this.state.savedDevices[i].deviceType,
            device);
        }
        else {
          deviceImage = this.getDeviceImagePathBasedOnDeviceType(
            this.state.savedDevices[i].deviceType);
        }

        // If an image could not be found for this device, we need to remove it from 
        // the saved devices because it most likely is not the same device anymore
        if (deviceImage === undefined) {
          devicesToDeleteFromSavedDevices.devicesToDelete.push({
            "id": this.state.savedDevices[i].id
          });
        }
        else {
          if (device !== "") {
            let label = this.state.savedDevices[i].label;

            label = label.substr(0, label.indexOf("\n"));
            label = label + "\n" + this.getNodeTag(device.tag);

            nodes.add({
              id: this.state.savedDevices[i].id,
              label: label,
              shape: "image",
              image: deviceImage,
              shapeProperties: {
                useImageSize: false
              },
              x: this.snapToGrid(this.state.savedDevices[i].x),
              y: this.snapToGrid(this.state.savedDevices[i].y),
              title: this.createNodeTitle(device)
            });
          }
          else {
            nodes.add({
              id: this.state.savedDevices[i].id,
              label: this.state.savedDevices[i].label,
              shape: "image",
              image: deviceImage,
              shapeProperties: {
                useImageSize: false
              },
              x: this.snapToGrid(this.state.savedDevices[i].x),
              y: this.snapToGrid(this.state.savedDevices[i].y)
            });
          }
        }
      }
    }
  }

  createConnections = () => {
    edges = new DataSet();

    for (let i = 0; i < this.state.connections.length; i++) {

      // Check if the devices with problems have connections. If they do save the connections to be deleted
      for (let j = 0; j < devicesToDeleteFromSavedDevices.devicesToDelete.length; j++) {

        if (this.state.connections[i].from === devicesToDeleteFromSavedDevices.devicesToDelete[j].id
          || this.state.connections[i].to === devicesToDeleteFromSavedDevices.devicesToDelete[j].id) {

          connectionsToDeleteFromSavedConnections.connectionsToDelete.push({
            "from": this.state.connections[i].from,
            "to": this.state.connections[i].to
          });

        }
      }

      edges.add({
        from: this.state.connections[i].from,
        to: this.state.connections[i].to,
        color: {
          color: this.state.connections[i].color,
          highlight: this.state.connections[i].color,
          hover: this.state.connections[i].color,
          inherit: "from",
          opacity: 1.0
        },
        width: 2.0
      });
    }
  }

  createNetwork = (isPhysicsOn) => {
    let container = document.getElementById(NETWORK_ID);

    let data = {
      nodes: nodes,
      edges: edges
    };

    let locales = {
      pt_br: {
        edit: Strings.LOCALE_EDIT,
        del: Strings.LOCALE_DEL,
        back: Strings.LOCALE_BACK,
        addNode: Strings.LOCALE_ADD_NODE,
        addEdge: Strings.LOCALE_ADD_EDGE,
        editNode: Strings.LOCALE_EDIT_NODE,
        editEdge: Strings.LOCALE_EDIT_EDGE,
        addDescription: Strings.LOCALE_ADD_DESCRIPTION,
        edgeDescription: Strings.LOCALE_EDGE_DESCRIPTION,
        editEdgeDescription: Strings.LOCALE_EDIT_EDGE_DESCRIPTION,
        createEdgeError: Strings.LOCALE_CREATE_EDGE_ERROR,
        deleteClusterError: Strings.LOCALE_DELETE_CLUSTER_ERROR,
        editClusterError: Strings.LOCALE_EDIT_CLUSTER_ERROR
      }
    };

    networkOptions = {
      autoResize: true,
      height: "100%",
      width: "100%",
      locale: "pt_br",
      locales: locales,
      interaction: {
        hover: true
      },
      edges: {
        smooth: false
      },
      physics: {
        enabled: isPhysicsOn,
        stabilization: isPhysicsOn
      },
      layout: {
        improvedLayout: false
      },
      manipulation: {
        enabled: true,
        initiallyActive: true,
        addNode: (data, callback) => {
          // Reset the device type then open the modal
          this.setState({ deviceType: "" }, () => {
            this.setState({ isAddDeviceModalOpen: true });
          });
          document.getElementById(ADD_DEVICE_MODAL_CLOSE_ID).onclick = () => {
            this.closeAddDeviceModal();
          };
          document.getElementById(ADD_DEVICE_MODAL_OK_ID).onclick = () => {
            this.addDevice(data, callback);
          };
        },
        addEdge: (edgeData, callback) => {
          edgeData = this.applyConnectionTypeToEdge(
            edgeData,
            this.state.defaultConnectionColorType
          );

          callback(edgeData);
        },
        editNode: (nodeData, callback) => {
          // If the device ID is a number, that means its information came from the live list 
          if (typeof (nodeData.id) === "number") {
            // If the device is not the master we can edit its image
            if (!this.isDeviceMaster(nodeData.id)) {
              // Reset the device type then open the modal
              this.setState({ deviceType: "" }, () => {
                this.setState({ isEditLiveListDeviceModalOpen: true });
              });
              document.getElementById(EDIT_LL_DEVICE_MODAL_CLOSE_ID).onclick = () => {
                this.closeEditLiveListDeviceModal();
                callback(nodeData);
              };
              document.getElementById(EDIT_LL_DEVICE_MODAL_OK_ID).onclick = () => {
                this.editLiveListDevice(nodeData, callback);
              };
            }
            else {
              alert(Strings.ALERT_NOT_POSSIBLE_TO_EDIT);
              callback(nodeData);
            }
          }
          else if (typeof (nodeData.id) === "string" && UtilsInstance.validateIPAddress(nodeData.id)) {
            alert(Strings.ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE);
            callback(null);
          }
          else {
            this.setState({
              isEditDeviceModalOpen: true,
              editDeviceTagInputValue: this.getTagFromDeviceLabel(nodeData.label)
            });

            document.getElementById(EDIT_DEVICE_MODAL_CLOSE_ID).onclick = () => {
              this.closeEditDeviceModal();
              callback(nodeData);
            };
            document.getElementById(EDIT_DEVICE_MODAL_OK_ID).onclick = () => {
              this.editDevice(nodeData, callback);
            };
          }
        },
        editEdge: true,
        deleteNode: (data, callback) => {
          // If the device ID is a number, that means its information came from the live list 
          if (typeof (data.nodes[0]) === "number") {

            let canDelete = true;
            // Search for the node in the live list, if it's there we can't delete it
            for (let i = 0; i < this.state.devices.length; i++) {
              if (data.nodes[0] === this.state.devices[i].address) {
                canDelete = false;
                break;
              }
            }

            // If it's not in the live list that means the node is 
            // not part of the network anymore, so we can safely delete it
            if (canDelete) {
              callback(data);
            }
            else {
              alert(Strings.ALERT_NOT_POSSIBLE_TO_DELETE);
              callback(null);
            }
          }
          else {
            callback(data);
          }
        },
        deleteEdge: true,
      }
    };

    network = new Network(container, data, networkOptions);

    network.on("dragEnd", (params) => {
      if (!params.nodes || params.nodes.length === 0) return;

      network.storePositions();

      const updates = params.nodes.map((id) => {
        const node = nodes.get(id);
        return {
          id,
          x: this.snapToGrid(node.x),
          y: this.snapToGrid(node.y)
        };
      });

      nodes.update(updates);
    });

    network.on("afterDrawing", () => {
    });
  }

  setNetworkOptions = (isPhysicsOn) => {
    let locales = {
      pt_br: {
        edit: Strings.LOCALE_EDIT,
        del: Strings.LOCALE_DEL,
        back: Strings.LOCALE_BACK,
        addNode: Strings.LOCALE_ADD_NODE,
        addEdge: Strings.LOCALE_ADD_EDGE,
        editNode: Strings.LOCALE_EDIT_NODE,
        editEdge: Strings.LOCALE_EDIT_EDGE,
        addDescription: Strings.LOCALE_ADD_DESCRIPTION,
        edgeDescription: Strings.LOCALE_EDGE_DESCRIPTION,
        editEdgeDescription: Strings.LOCALE_EDIT_EDGE_DESCRIPTION,
        createEdgeError: Strings.LOCALE_CREATE_EDGE_ERROR,
        deleteClusterError: Strings.LOCALE_DELETE_CLUSTER_ERROR,
        editClusterError: Strings.LOCALE_EDIT_CLUSTER_ERROR
      }
    };

    network.setOptions(
      {
        autoResize: true,
        height: "100%",
        width: "100%",
        locale: "pt_br",
        locales: locales,
        interaction: {
          hover: true
        },
        edges: {
          smooth: false
        },
        physics: {
          enabled: isPhysicsOn,
          stabilization: isPhysicsOn
        },
        layout: {
          improvedLayout: false
        },
        manipulation: {
          enabled: true,
          initiallyActive: true,
          addNode: (data, callback) => {
            // Reset the device type then open the modal
            this.setState({ deviceType: "" }, () => {
              this.setState({ isAddDeviceModalOpen: true });
            });
            document.getElementById(ADD_DEVICE_MODAL_CLOSE_ID).onclick = () => {
              this.closeAddDeviceModal();
            };
            document.getElementById(ADD_DEVICE_MODAL_OK_ID).onclick = () => {
              this.addDevice(data, callback);
            };
          },
          addEdge: (edgeData, callback) => {
            edgeData = this.applyConnectionTypeToEdge(
              edgeData,
              this.state.defaultConnectionColorType
            );

            callback(edgeData);
          },
          editNode: (nodeData, callback) => {
            // If the device ID is a number, that means its information came from the live list 
            if (typeof (nodeData.id) === "number") {
              // If the device is not the master we can edit its image
              if (!this.isDeviceMaster(nodeData.id)) {
                // Reset the device type then open the modal
                this.setState({ deviceType: "" }, () => {
                  this.setState({ isEditLiveListDeviceModalOpen: true });
                });
                document.getElementById(EDIT_LL_DEVICE_MODAL_CLOSE_ID).onclick = () => {
                  this.closeEditLiveListDeviceModal();
                  callback(nodeData);
                };
                document.getElementById(EDIT_LL_DEVICE_MODAL_OK_ID).onclick = () => {
                  this.editLiveListDevice(nodeData, callback);
                };
              }
              else {
                alert(Strings.ALERT_NOT_POSSIBLE_TO_EDIT);
                callback(nodeData);
              }
            }
            else if (typeof (nodeData.id) === "string" && UtilsInstance.validateIPAddress(nodeData.id)) {
              alert(Strings.ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE);
              callback(null);
            }
            else {
              this.setState({
                isEditDeviceModalOpen: true,
                editDeviceTagInputValue: this.getTagFromDeviceLabel(nodeData.label)
              });

              document.getElementById(EDIT_DEVICE_MODAL_CLOSE_ID).onclick = () => {
                this.closeEditDeviceModal();
                callback(nodeData);
              };
              document.getElementById(EDIT_DEVICE_MODAL_OK_ID).onclick = () => {
                this.editDevice(nodeData, callback);
              };
            }
          },
          editEdge: true,
          deleteNode: (data, callback) => {
            // If the device ID is a number, that means its information came from the live list 
            if (typeof (data.nodes[0]) === "number") {

              let canDelete = true;
              // Search for the node in the live list, if it's there we can't delete it
              for (let i = 0; i < this.state.devices.length; i++) {
                if (data.nodes[0] === this.state.devices[i].address) {
                  canDelete = false;
                  break;
                }
              }

              // If it's not in the live list that means the node is 
              // not part of the network anymore, so we can safely delete it
              if (canDelete) {
                callback(data);
              }
              else {
                alert(Strings.ALERT_NOT_POSSIBLE_TO_DELETE);
                callback(null);
              }
            }
            else {
              callback(data);
            }
          },
          deleteEdge: true,
        }
      }
    );
  }

  getDeviceStatus = (id) => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].address.toString() === id.toString()) {
        return this.state.devices[i].status;
      }
    }
    return "";
  }

  getDeviceFromLiveList = (id) => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].address.toString() === id.toString()) {
        return this.state.devices[i];
      }
    }
    return "";
  }

  // Returns the image path corresponding to the device status
  getDeviceImagePath = (device) => {
    if (device.isInAutomaticBlacklist) {
      return Constants.SLAVE_CRITICAL_IMG_PATH;
    }
    else if (device.isInBlacklist) {
      return Constants.SLAVE_BLACKLIST_IMG_PATH;
    }
    else {
      if (device.status === Constants.OK) {
        return Constants.SLAVE_OK_IMG_PATH;
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        return Constants.SLAVE_DIAGNOSTIC_IMG_PATH;
      }
      else if (device.status === Constants.ONLINE) {
        return Constants.SLAVE_ONLINE_IMG_PATH;
      }
      else if (device.status === Constants.FAULT) {
        return Constants.SLAVE_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.CONFIG_ERROR) {
        return Constants.SLAVE_CONFIG_ERROR_IMG_PATH;
      }
      else if (device.status === Constants.PARAM_ERROR) {
        return Constants.SLAVE_PARAM_ERROR_IMG_PATH;
      }
      else if (device.status === Constants.MASTER) {
        if (device.masterStatus === "operate") {
          return Constants.MASTER_IMG_PATH;
        }
        else {
          return Constants.MASTER_OTHER_IMG_PATH;
        }
      }
      else if (device.status === Constants.MASTER_FAULT) {
        return Constants.MASTER_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.SLAVE_MASTER_FAULT) {
        return Constants.SLAVE_MASTER_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.MPI) {
        return Constants.MPI_IMG_PATH;
      }
      else if (device.status === Constants.MPI_FAULT) {
        return Constants.MPI_FAULT_IMG_PATH;
      }
      else if (device.status === Constants.MISSING) {
        return Constants.SLAVE_MISSING_IMG_PATH;
      }
      else {
        return Constants.SLAVE_IMG_PATH;
      }
    }
  }

  // Returns the image path corresponding to a device type
  getDeviceImagePathBasedOnDeviceType = (deviceType) => {
    if (deviceType === MASTER_DEVICE_TYPE) {
      return Constants.MASTER_IMG_PATH;
    }
    else if (deviceType === SLAVE_DEVICE_TYPE) {
      return Constants.SLAVE_IMG_PATH;
    }
    else if (deviceType === SLAVE_PA_DEVICE_TYPE) {
      return Constants.SLAVE_PA_IMG_PATH;
    }
    else if (deviceType === REPEATER_DEVICE_TYPE) {
      return Constants.REPEATER_IMG_PATH;
    }
    else if (deviceType === HUB_DEVICE_TYPE) {
      return Constants.HUB_IMG_PATH;
    }
    else if (deviceType === JB_DEVICE_TYPE) {
      return Constants.JB_IMG_PATH;
    }
    else if (deviceType === COUPLER_PROXY_DEVICE_TYPE) {
      return Constants.COUPLER_PROXY_IMG_PATH;
    }
    else if (deviceType === FIBER_LINK_DEVICE_TYPE) {
      return Constants.FIBER_LINK_IMG_PATH;
    }
    else if (deviceType === ACTIVE_TERMINATION_DEVICE_TYPE) {
      return Constants.ACTIVE_TERMINATION_IMG_PATH;
    }
    else if (deviceType === TS_MONITOR_DEVICE_TYPE) {
      return Constants.TS_MONITOR_IMG_PATH;
    }
    else if (deviceType === MPI_DEVICE_TYPE) {
      return Constants.MPI_IMG_PATH;
    }
    else if (deviceType === TS_SCOPE_DP_TYPE) {
      return Constants.TS_SCOPE_DP_IMG_PATH;
    }
    else if (deviceType === TS_SCOPE_PA_TYPE) {
      return Constants.TS_SCOPE_PA_IMG_PATH;
    }
    else {
      return Constants.SLAVE_IMG_PATH;
    }
  }

  // Returns the device type corresponding to a image path
  getDeviceTypeBasedOnDeviceImagePath = (path) => {
    if (path === Constants.MASTER_IMG_PATH
      || path === Constants.MASTER_FAULT_IMG_PATH
      || path === Constants.MASTER_OTHER_IMG_PATH) {
      return MASTER_DEVICE_TYPE;
    }
    else if (path === Constants.SLAVE_IMG_PATH
      || path === Constants.SLAVE_OK_IMG_PATH
      || path === Constants.SLAVE_DIAGNOSTIC_IMG_PATH
      || path === Constants.SLAVE_FAULT_IMG_PATH
      || path === Constants.SLAVE_CONFIG_ERROR_IMG_PATH
      || path === Constants.SLAVE_PARAM_ERROR_IMG_PATH
      || path === Constants.SLAVE_ONLINE_IMG_PATH
      || path === Constants.SLAVE_CRITICAL_IMG_PATH
      || path === Constants.SLAVE_BLACKLIST_IMG_PATH
      || path === Constants.SLAVE_MASTER_FAULT_IMG_PATH
      || path === Constants.SLAVE_MISSING_IMG_PATH) {
      return SLAVE_DEVICE_TYPE;
    }
    else if (path === Constants.SLAVE_PA_IMG_PATH
      || path === Constants.SLAVE_PA_OK_IMG_PATH
      || path === Constants.SLAVE_PA_DIAGNOSTIC_IMG_PATH
      || path === Constants.SLAVE_PA_FAULT_IMG_PATH
      || path === Constants.SLAVE_PA_CONFIG_ERROR_IMG_PATH
      || path === Constants.SLAVE_PA_PARAM_ERROR_IMG_PATH
      || path === Constants.SLAVE_PA_ONLINE_IMG_PATH
      || path === Constants.SLAVE_PA_BLACKLIST_IMG_PATH
      || path === Constants.SLAVE_PA_CRITICAL_IMG_PATH
      || path === Constants.SLAVE_PA_MASTER_FAULT_IMG_PATH
      || path === Constants.SLAVE_PA_MISSING_IMG_PATH) {
      return SLAVE_PA_DEVICE_TYPE;
    }
    else if (path === Constants.REPEATER_IMG_PATH
      || path === Constants.REPEATER_OK_IMG_PATH
      || path === Constants.REPEATER_DIAGNOSTIC_IMG_PATH
      || path === Constants.REPEATER_FAULT_IMG_PATH
      || path === Constants.REPEATER_CONFIG_ERROR_IMG_PATH
      || path === Constants.REPEATER_PARAM_ERROR_IMG_PATH
      || path === Constants.REPEATER_ONLINE_IMG_PATH
      || path === Constants.REPEATER_BLACKLIST_ERROR_IMG_PATH
      || path === Constants.REPEATER_CRITICAL_IMG_PATH
      || path === Constants.REPEATER_MASTER_FAULT_IMG_PATH
      || path === Constants.REPEATER_MISSING_IMG_PATH) {
      return REPEATER_DEVICE_TYPE;
    }
    else if (path === Constants.HUB_IMG_PATH) {
      return HUB_DEVICE_TYPE;
    }
    else if (path === Constants.JB_IMG_PATH) {
      return JB_DEVICE_TYPE;
    }
    else if (path === Constants.COUPLER_PROXY_IMG_PATH
      || path === Constants.COUPLER_PROXY_OK_IMG_PATH
      || path === Constants.COUPLER_PROXY_DIAGNOSTIC_IMG_PATH
      || path === Constants.COUPLER_PROXY_FAULT_IMG_PATH
      || path === Constants.COUPLER_PROXY_CONFIG_ERROR_IMG_PATH
      || path === Constants.COUPLER_PROXY_PARAM_ERROR_IMG_PATH
      || path === Constants.COUPLER_PROXY_ONLINE_IMG_PATH
      || path === Constants.COUPLER_PROXY_CRITICAL_IMG_PATH
      || path === Constants.COUPLER_PROXY_BLACKLIST_IMG_PATH
      || path === Constants.COUPLER_PROXY_MASTER_FAULT_IMG_PATH
      || path === Constants.COUPLER_PROXY_MISSING_IMG_PATH) {
      return COUPLER_PROXY_DEVICE_TYPE;
    }
    else if (path === Constants.FIBER_LINK_IMG_PATH) {
      return FIBER_LINK_DEVICE_TYPE;
    }
    else if (path === Constants.ACTIVE_TERMINATION_IMG_PATH) {
      return ACTIVE_TERMINATION_DEVICE_TYPE;
    }
    else if (path === Constants.TS_MONITOR_IMG_PATH) {
      return TS_MONITOR_DEVICE_TYPE;
    }
    else if (path === Constants.MPI_IMG_PATH) {
      return MPI_DEVICE_TYPE;
    }
    else if (path === Constants.MPI_FAULT_IMG_PATH) {
      return MPI_DEVICE_TYPE;
    }
    else if (path === Constants.TS_SCOPE_DP_IMG_PATH) {
      return TS_SCOPE_DP_TYPE;
    }
    else if (path === Constants.TS_SCOPE_PA_IMG_PATH) {
      return TS_SCOPE_PA_TYPE;
    }
    else {
      return SLAVE_DEVICE_TYPE;
    }
  }

  getDeviceImagePathBasedOnDeviceTypeAndStatus = (deviceType, device) => {
    if (deviceType === MASTER_DEVICE_TYPE) {
      if (device.status === Constants.MASTER) {
        if (device.masterStatus === "operate") {
          return Constants.MASTER_IMG_PATH;
        }
        else {
          return Constants.MASTER_OTHER_IMG_PATH;
        }
      }
      else if (device.status === Constants.MASTER_FAULT) {
        return Constants.MASTER_FAULT_IMG_PATH;
      }
    }
    else if (deviceType === SLAVE_DEVICE_TYPE) {
      if (device.isInAutomaticBlacklist) {
        return Constants.SLAVE_CRITICAL_IMG_PATH;
      }
      else if (device.isInBlacklist) {
        return Constants.SLAVE_BLACKLIST_IMG_PATH;
      }
      else {
        if (device.status === Constants.OK) {
          return Constants.SLAVE_OK_IMG_PATH;
        }
        else if (device.status === Constants.DIAGNOSTIC) {
          return Constants.SLAVE_DIAGNOSTIC_IMG_PATH;
        }
        else if (device.status === Constants.ONLINE) {
          return Constants.SLAVE_ONLINE_IMG_PATH;
        }
        else if (device.status === Constants.FAULT) {
          return Constants.SLAVE_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.CONFIG_ERROR) {
          return Constants.SLAVE_CONFIG_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.PARAM_ERROR) {
          return Constants.SLAVE_PARAM_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.SLAVE_MASTER_FAULT) {
          return Constants.SLAVE_MASTER_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.MISSING) {
          return Constants.SLAVE_MISSING_IMG_PATH;
        }
      }
    }
    else if (deviceType === SLAVE_PA_DEVICE_TYPE) {
      if (device.isInAutomaticBlacklist) {
        return Constants.SLAVE_PA_CRITICAL_IMG_PATH;
      }
      else if (device.isInBlacklist) {
        return Constants.SLAVE_PA_BLACKLIST_IMG_PATH;
      }
      else {
        if (device.status === Constants.OK) {
          return Constants.SLAVE_PA_OK_IMG_PATH;
        }
        else if (device.status === Constants.DIAGNOSTIC) {
          return Constants.SLAVE_PA_DIAGNOSTIC_IMG_PATH;
        }
        else if (device.status === Constants.ONLINE) {
          return Constants.SLAVE_PA_ONLINE_IMG_PATH;
        }
        else if (device.status === Constants.FAULT) {
          return Constants.SLAVE_PA_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.CONFIG_ERROR) {
          return Constants.SLAVE_PA_CONFIG_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.PARAM_ERROR) {
          return Constants.SLAVE_PA_PARAM_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.SLAVE_MASTER_FAULT) {
          return Constants.SLAVE_PA_MASTER_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.MISSING) {
          return Constants.SLAVE_PA_MISSING_IMG_PATH;
        }
      }
    }
    else if (deviceType === REPEATER_DEVICE_TYPE) {
      if (device.isInAutomaticBlacklist) {
        return Constants.REPEATER_CRITICAL_IMG_PATH;
      }
      else if (device.isInBlacklist) {
        return Constants.REPEATER_BLACKLIST_ERROR_IMG_PATH;
      }
      else {
        if (device.status === Constants.OK) {
          return Constants.REPEATER_OK_IMG_PATH;
        }
        else if (device.status === Constants.DIAGNOSTIC) {
          return Constants.REPEATER_DIAGNOSTIC_IMG_PATH;
        }
        else if (device.status === Constants.ONLINE) {
          return Constants.REPEATER_ONLINE_IMG_PATH;
        }
        else if (device.status === Constants.FAULT) {
          return Constants.REPEATER_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.CONFIG_ERROR) {
          return Constants.REPEATER_CONFIG_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.PARAM_ERROR) {
          return Constants.REPEATER_PARAM_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.SLAVE_MASTER_FAULT) {
          return Constants.REPEATER_MASTER_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.MISSING) {
          return Constants.REPEATER_MISSING_IMG_PATH;
        }
      }
    }
    else if (deviceType === COUPLER_PROXY_DEVICE_TYPE) {
      if (device.isInAutomaticBlacklist) {
        return Constants.COUPLER_PROXY_CRITICAL_IMG_PATH;
      }
      else if (device.isInBlacklist) {
        return Constants.COUPLER_PROXY_BLACKLIST_IMG_PATH;
      }
      else {
        if (device.status === Constants.OK) {
          return Constants.COUPLER_PROXY_OK_IMG_PATH;
        }
        else if (device.status === Constants.DIAGNOSTIC) {
          return Constants.COUPLER_PROXY_DIAGNOSTIC_IMG_PATH;
        }
        else if (device.status === Constants.ONLINE) {
          return Constants.COUPLER_PROXY_ONLINE_IMG_PATH;
        }
        else if (device.status === Constants.FAULT) {
          return Constants.COUPLER_PROXY_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.CONFIG_ERROR) {
          return Constants.COUPLER_PROXY_CONFIG_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.PARAM_ERROR) {
          return Constants.COUPLER_PROXY_PARAM_ERROR_IMG_PATH;
        }
        else if (device.status === Constants.SLAVE_MASTER_FAULT) {
          return Constants.COUPLER_PROXY_MASTER_FAULT_IMG_PATH;
        }
        else if (device.status === Constants.MISSING) {
          return Constants.COUPLER_PROXY_MISSING_IMG_PATH;
        }
      }
    }
    else if (deviceType === MPI_DEVICE_TYPE) {
      if (device.status === Constants.MPI) {
        return Constants.MPI_IMG_PATH;
      }
      else if (device.status === Constants.MPI_FAULT) {
        return Constants.MPI_FAULT_IMG_PATH;
      }
    }
    else {
      return Constants.SLAVE_IMG_PATH;
    }
  }

  getDeviceLabelStringBasedOnType = (deviceType) => {
    let labelString = "";

    if (deviceType === MASTER_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.MASTER_NAME;
    }
    else if (deviceType === SLAVE_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.SLAVE_NAME;
    }
    else if (deviceType === SLAVE_PA_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.SLAVE_PA_NAME;
    }
    else if (deviceType === REPEATER_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.REPEATER_NAME;
    }
    else if (deviceType === HUB_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.HUB_NAME;
    }
    else if (deviceType === JB_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.JB_NAME;
    }
    else if (deviceType === COUPLER_PROXY_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.COUPLER_PROXY_NAME;
    }
    else if (deviceType === FIBER_LINK_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.FIBER_LINK_NAME;
    }
    else if (deviceType === ACTIVE_TERMINATION_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.ACTIVE_TERMINATION_NAME;
    }
    else if (deviceType === TS_MONITOR_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.TS_MONITOR_NAME;
    }
    else if (deviceType === MPI_DEVICE_TYPE) {
      labelString = document.getElementById(ADD_DEVICE_TAG_ID).value + "\n" + Strings.MPI_NAME;
    }
    else if (deviceType === TS_SCOPE_DP_TYPE) {
      labelString = document.getElementById(ADD_SCOPE_IP_ID).value + "\n" + Strings.TS_SCOPE_DP_NAME;
    }
    else if (deviceType === TS_SCOPE_PA_TYPE) {
      labelString = document.getElementById(ADD_SCOPE_IP_ID).value + "\n" + Strings.TS_SCOPE_PA_NAME;
    }

    return labelString;
  }

  isDeviceMaster = (id) => {
    for (let i = 0; i < this.state.devices.length; i++) {
      if (this.state.devices[i].address === id) {
        if (this.state.devices[i].status === Constants.MASTER
          || this.state.devices[i].status === Constants.MASTER_FAULT) {
          return true;
        }
        else {
          return false;
        }
      }
    }
    return false;
  }

  applyConnectionTypeToEdge = (edgeData, connectionType) => {
    edgeData.color = this.getConnectionColor(connectionType);
    edgeData.width = 2.0;

    return edgeData;
  }

  getConnectionColor = (connectionType) => {
    if (connectionType === Constants.PROFIBUS_DP_COLOR_TYPE) {
      return {
        color: DP_STANDARD_COLOR,
        highlight: DP_STANDARD_COLOR,
        hover: DP_STANDARD_COLOR,
        inherit: "from",
        opacity: 1.0
      };
    }
    else if (connectionType === Constants.PROFIBUS_DP_IS_COLOR_TYPE) {
      return {
        color: DP_HAZARDOUS_COLOR,
        highlight: DP_HAZARDOUS_COLOR,
        hover: DP_HAZARDOUS_COLOR,
        inherit: "from",
        opacity: 1.0
      };
    }
    else if (connectionType === Constants.PROFIBUS_MBP_PA_NON_HAZ_COLOR_TYPE) {
      return {
        color: PA_STANDARD_COLOR,
        highlight: PA_STANDARD_COLOR,
        hover: PA_STANDARD_COLOR,
        inherit: "from",
        opacity: 1.0
      };
    }
    else if (connectionType === Constants.PROFIBUS_MBP_PA_HAZ_COLOR_TYPE) {
      return {
        color: PA_HAZARDOUS_COLOR,
        highlight: PA_HAZARDOUS_COLOR,
        hover: PA_HAZARDOUS_COLOR,
        inherit: "from",
        opacity: 1.0
      };
    }
    else if (connectionType === Constants.PROFIBUS_OPTIC_FIBER_COLOR_TYPE) {
      return {
        color: OPTIC_FIBER_COLOR,
        highlight: OPTIC_FIBER_COLOR,
        hover: OPTIC_FIBER_COLOR,
        inherit: "from",
        opacity: 1.0
      };
    }
  }

  // The label is composed of the tag + "\n" + device type
  getTagFromDeviceLabel = (label) => {
    let tag = "";
    for (let i = 0; i < label.length; i++) {
      if (label[i] === "\n") {
        return tag;
      }
      tag = tag.concat(label[i]);
    }
    return "";
  }

  // ----------------- Device manipulation ----------------
  closeAddDeviceModal = () => {
    this.setState({
      isAddDeviceModalOpen: false,
      addDeviceTagInputValue: "" // Reset the tag value
    });
  }

  closeAddConnectionModal = () => {
    this.setState({ isAddConnectionModalOpen: false });
  }

  closeEditDeviceModal = () => {
    this.setState({
      isEditDeviceModalOpen: false,
      editDeviceTagInputValue: "" // Reset the tag value
    });
  }

  closeEditLiveListDeviceModal = () => {
    this.setState({ isEditLiveListDeviceModalOpen: false });
  }

  addDevice = async (data, callback) => {
    if (this.state.deviceType === "") {
      alert(Strings.ALERT_CHOOSE_DEVICE_TYPE);
    }
    else {
      if (this.state.deviceType === TS_SCOPE_DP_TYPE || this.state.deviceType === TS_SCOPE_PA_TYPE) {
        // Se o usuário escolheu adicionar um device do tipo TS Scope, verificamos
        // se endereço de IP digitado é valido
        if (UtilsInstance.validateIPAddress(this.state.addScopeIpInputValue)) {

          // Em seguida verificamos se o TS Scope responde uma requisição
          // que retorna o tipo de ts scope que ele é 
          let type = await this.getTsScopeType(this.state.addScopeIpInputValue);

          // Se o resultado foi "ts-scope-dp" ou "ts-scope-pa" é por que é realmente
          // um TS Scope, então podemos adicioná-lo
          if (type === TS_SCOPE_DP_TYPE || type === TS_SCOPE_PA_TYPE
            || type === OLD_TS_SCOPE_DP_TYPE || type === OLD_TS_SCOPE_PA_TYPE) {

            let imagePath = this.getDeviceImagePathBasedOnDeviceType(this.state.deviceType);
            let labelString = this.getDeviceLabelStringBasedOnType(this.state.deviceType);

            data.id = this.state.addScopeIpInputValue;  // O id é o IP do TS Scope
            data.label = labelString;
            data.shape = "image";
            data.image = imagePath;
            data.shapeProperties = {
              useImageSize: false
            };
            this.setState({
              isAddDeviceModalOpen: false,
              addDeviceTagInputValue: "", // Reset the tag value
              addScopeIpInputValue: ""    // Reset the ip value
            });
            callback(data);
          }
          // Se o resultado for diferente de "ts-scope-dp" ou "ts-scope-pa"
          // ou ninguém respondeu, ou quem respondeu não é um TS Scope
          else {
            alert(Strings.TS_SCOPE_NOT_FOUND + this.state.addScopeIpInputValue);
          }
        }
        else {
          alert(Strings.INVALID_INSERTED_IP);
        }
      }
      else {
        let imagePath = this.getDeviceImagePathBasedOnDeviceType(this.state.deviceType);
        let labelString = this.getDeviceLabelStringBasedOnType(this.state.deviceType);

        data.label = labelString;
        data.shape = "image";
        data.image = imagePath;
        data.shapeProperties = {
          useImageSize: false
        };
        data.x = this.snapToGrid(data.x);
        data.y = this.snapToGrid(data.y);
        this.setState({
          isAddDeviceModalOpen: false,
          addDeviceTagInputValue: "", // Reset the tag value
          addScopeIpInputValue: ""    // Reset the ip value
        });
        callback(data);
      }
    }
  }

  getTsScopeType = async (addScopeIpInputValue) => {
    let didTimeOut = false;

    let promise = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        didTimeOut = true;
        reject(new Error(Strings.TS_SCOPE_NOT_FOUND + addScopeIpInputValue));
      }, FETCH_TS_SCOPE_TIMEOUT);

      return fetch("http://" + addScopeIpInputValue + ":5000/productType", { mode: "cors" })
        .then((res) => {
          clearTimeout(timeout);
          if (!didTimeOut) {
            console.log(Strings.TS_SCOPE_FETCH_SUCCESS);
          }
          resolve(res);
        })
        .catch((error) => {
          // Rejection already happened with setTimeout
          if (didTimeOut) return;
          // Reject with error
          reject(error);
        });
    })
      .then(res => res.json())
      .then(data => data.type)
      .catch((error) => {
        // Error: response error, request timeout or runtime error
        console.log(error.message);
      });

    let result = await promise;

    return result;
  }


  editDevice = (nodeData, callback) => {
    let deviceTypeLabel = nodeData.label.split("\n")[1];
    let deviceTag = this.state.editDeviceTagInputValue;

    let newDeviceLabel = deviceTag + "\n" + deviceTypeLabel;

    nodeData.label = newDeviceLabel;
    nodeData.title = deviceTag;

    this.setState({
      isEditDeviceModalOpen: false,
      editDeviceTagInputValue: "" // Reset the tag value
    });

    callback(nodeData);
  }

  editLiveListDevice = (nodeData, callback) => {
    // Only let the user press the edit button if he did choose a device type
    if (this.state.deviceType === "") {
      alert(Strings.ALERT_CHOOSE_DEVICE_TYPE);
    }
    else {
      let deviceStatus = this.getDeviceStatus(nodeData.id);
      let device = this.getDeviceFromLiveList(nodeData.id);
      let imagePath = this.getDeviceImagePathBasedOnDeviceTypeAndStatus(this.state.deviceType, device);

      // Save the choosen device type to the map
      this.updateLiveListDeviceTypeMap(nodeData.id, this.state.deviceType);

      liveListDeviceTypeMap[nodeData.id] = {
        status: deviceStatus,
        devType: this.state.deviceType
      };

      // Then change the image
      nodeData.shape = "image";
      nodeData.image = imagePath;
      nodeData.shapeProperties = {
        useImageSize: false
      };

      this.setState({ isEditLiveListDeviceModalOpen: false });
      callback(nodeData);
    }
  }

  onConnectionDropdownChange = (e, { value }) => this.setState({ connectionColorType: value })

  onTypeDropdownChange = (e, { value }) => {
    this.setState({ deviceType: value }, () => {
      let scopeIdElements = document.getElementsByClassName(ADD_SCOPE_IP_ID);
      let deviceTagElements = document.getElementsByClassName(ADD_DEVICE_TAG_ID);

      if (this.state.deviceType === TS_SCOPE_DP_TYPE) {
        for (let i = 0; i < scopeIdElements.length; i++) {
          scopeIdElements[i].style.display = "flex";
        }

        for (let i = 0; i < deviceTagElements.length; i++) {
          deviceTagElements[i].style.display = "none";
        }
      }
      else if (this.state.deviceType === TS_SCOPE_PA_TYPE) {
        for (let i = 0; i < scopeIdElements.length; i++) {
          scopeIdElements[i].style.display = "flex";
        }

        for (let i = 0; i < deviceTagElements.length; i++) {
          deviceTagElements[i].style.display = "none";
        }
      }
      else {
        for (let i = 0; i < scopeIdElements.length; i++) {
          scopeIdElements[i].style.display = "none";
        }

        for (let i = 0; i < deviceTagElements.length; i++) {
          deviceTagElements[i].style.display = "flex";
        }
      }
    });
  }

  onChangeDeviceInput = (e, data) => {
    if (data.value.length <= 20) {
      this.setState({
        addDeviceTagInputValue: data.value
      });
    }
  }

  onChangeEditDeviceInput = (e, data) => {
    if (data.value.length <= 20) {
      this.setState({
        editDeviceTagInputValue: data.value
      });
    }
  }

  onChangeScopeIpInput = (e, data) => {
    if (data.value.length <= 15) {
      this.setState({
        addScopeIpInputValue: data.value
      });
    }
  }

  // ----------------- Right sidebar buttons -----------------

  // Pauses the network physics so the user can manually adjust the nodes positioning
  handleEditNodesPositionClick = () => {
    this.setNetworkOptions(false);
  }

  // Saves the position of each of the nodes so we can position them
  // on the same place when refreshing the page
  handleSaveNodesPositionClick = () => {
    this.snapAllNodesToGrid();

    let networkInformation = {
      devices: []
    };

    let connectivityInformation = {
      edges: []
    };

    nodes.forEach((node) => {
      let nodeInfo = {
        "label": node.label,
        "id": node.id,
        "x": node.x,
        "y": node.y,
        "deviceType": this.getDeviceTypeBasedOnDeviceImagePath(node.image)
      };
      networkInformation.devices.push(nodeInfo);
    });

    edges.forEach((edge) => {
      let edgeInfo = {
        "from": edge.from,
        "to": edge.to,
        "color": edge.color.color
      };
      connectivityInformation.edges.push(edgeInfo);
    });

    let networkData = JSON.stringify(networkInformation);
    let connectivityData = JSON.stringify(connectivityInformation);

    // Try to save the nodes of the network
    fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyNetworkSave_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: networkData
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        // Then try to save the connections
        fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyConnectivitySave_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: connectivityData
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.SAVE_TOPOLOGY_POS_SUCCESS_STRING);
            this.setNetworkOptions(false);
          })
          .catch((error) => {
            alert(Strings.SAVE_TOPOLOGY_POS_FAILURE_STRING + error);
          });
      })
      .catch((error) => {
        alert(Strings.SAVE_TOPOLOGY_POS_FAILURE_STRING + error);
      });
  }

  handleDeleteNodesPositionClick = () => {
    this.setState({ isDeletePositioningModalOpen: true });
  }

  handleDeleteNodesPositionModalPositiveClick = () => {
    this.setState({ isDeletePositioningModalOpen: false });

    let data = JSON.stringify({
      reset: "True"
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "graphicTopologyDrop_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.DROP_TOPOLOGY_POS_SUCCESS_STRING);
        this.setNetworkOptions(true);
        edges = new DataSet();
        this.retrieveData();
      })
      .catch((error) => {
        alert(Strings.DROP_TOPOLOGY_POS_FAILURE_STRING + error);
      });
  }

  handleDeleteNodesPositionModalNegativeClick = () => {
    this.setState({ isDeletePositioningModalOpen: false });
  }

  // ----------------- Image Export -----------------
  exportSvg = () => {
    let networkContainer = network.body.container;
    let ctx = new C2S({ width: networkContainer.clientWidth, height: networkContainer.clientWidth, enableMirroring: true });

    let canvasProto = network.canvas.__proto__;
    let currentGetContext = canvasProto.getContext;
    canvasProto.getContext = function () {
      return ctx;
    };
    let svgOptions = {
      nodes: {
        shapeProperties: {
          interpolation: false //so images are not scaled svg will get full image
        },
        scaling: { label: { drawThreshold: 0 } }
      },
      edges: {
        scaling: { label: { drawThreshold: 0 } }
      }
    };
    network.setOptions(svgOptions);
    canvasProto.getContext = currentGetContext;
    setTimeout(() => {
      let svg = ctx.getSerializedSvg();
      this.showSvg(svg);
    }, 1000);
  }

  showSvg = (svg) => {
    let svgBlob = new Blob([svg], { type: "image/svg+xml" });
    this.openBlob(svgBlob, "network.svg");
  }

  openBlob = (blob, fileName) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {

      //blobToDataURL(blob, function(dataurl){window.open(dataurl);});
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
      let a = document.getElementById("blobLink");
      if (!a) {
        a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("id", "blobLink");
        a.style = "display: none";
      }
      let data = window.URL.createObjectURL(blob);
      a.href = data;
      a.download = fileName;
      a.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    }
  }

  // ----------------- Remove Problematic Devices -----------------
  removeDevicesWithProblemsFromSavedDevicesAndConnections = () => {
    let networkData = JSON.stringify(devicesToDeleteFromSavedDevices);
    let connectivityData = JSON.stringify(connectionsToDeleteFromSavedConnections);

    // Try to remove the devices from saved devices
    fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyNodesDelete_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: networkData
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        // Then try to remove the connections that these devices had
        fetch(Constants.REQUEST_IP_ADDRESS + "/graphicTopologyConnectivityDelete_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: connectivityData
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS);

            // Reset the list of devices and connections with problems
            devicesToDeleteFromSavedDevices = { devicesToDelete: [] };
            connectionsToDeleteFromSavedConnections = { connectionsToDelete: [] };

            // and get the topology data again
            this.retrieveData();

          })
          .catch((error) => {
            alert(Strings.POSITIONING_ANG_CONNECTIONS_RESET_FAILURE + error);
          });
      })
      .catch((error) => {
        alert(Strings.POSITIONING_ANG_CONNECTIONS_RESET_FAILURE + error);
      });
  }

  // ----------------- Topology Import / Export -----------------
  exportTopology = () => {
    if (network !== undefined && network !== null) {
      this.snapAllNodesToGrid();

      let topologyInfo = {
        devices: [],
        edges: []
      };

      // Add the position and image type of each device
      nodes.forEach((node) => {
        let nodeInfo = {
          "label": node.label,
          "id": node.id,
          "x": node.x,
          "y": node.y,
          "deviceType": this.getDeviceTypeBasedOnDeviceImagePath(node.image)
        };
        topologyInfo.devices.push(nodeInfo);
      });
      // Add the connections
      edges.forEach((edge) => {
        let edgeInfo = {
          "from": edge.from,
          "to": edge.to,
          "color": edge.color.color
        };
        topologyInfo.edges.push(edgeInfo);
      });

      let topologyJSONInfo = JSON.stringify(topologyInfo);

      let dataStr = "data:application/json;charset=utf-8," + encodeURIComponent(topologyJSONInfo);
      let downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute("download", `${Strings.EXPORT_TOPOLOGY}.json`);
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    }
  }

  importTopology = () => {
    let fileInput = document.getElementById("import-topology-input-file");

    if (fileInput.files[0] !== undefined && fileInput.files[0] !== null) {
      let file = fileInput.files[0];
      let fileReader = new FileReader();

      // Import the topology information when the file is ready to be read
      fileReader.onload = (event) => {
        try {
          let topologyJSONObject = JSON.parse(event.target.result);

          // Check if saved devices or connections are not defined
          let areDevicesOk = topologyJSONObject.devices !== undefined && topologyJSONObject.devices !== null;
          let areEdgesOk = topologyJSONObject.edges !== undefined && topologyJSONObject.edges !== null;

          if (areDevicesOk && areEdgesOk) {
            // If there are no problems, save them
            let networkData = JSON.stringify({ devices: topologyJSONObject.devices });
            let connectivityData = JSON.stringify({ edges: topologyJSONObject.edges });

            // Try to save the nodes of the network
            fetch(Constants.REQUEST_IP_ADDRESS + "graphicTopologyNetworkSave_POST", {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              },
              body: networkData
            })
              .then(UtilsInstance.checkStatus)
              .then(() => {
                // Then try to save the connections
                fetch(Constants.REQUEST_IP_ADDRESS + "graphicTopologyConnectivitySave_POST", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                  },
                  body: connectivityData
                })
                  .then(UtilsInstance.checkStatus)
                  .then(() => {
                    alert(Strings.TOPOLOGY_IMPORT_SUCCESS);
                    // If everything was ok, retrieve data to refresh the network
                    this.retrieveData();
                  })
                  .catch((error) => {
                    alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + error);
                  });
              })
              .catch((error) => {
                alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + error);
              });
          }
          else {
            alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + Strings.INVALID_OR_CORRUPT_FILE);
          }
        }
        catch (error) {
          alert(Strings.ERROR_IMPORTING_GRAPHIC_TOPOLOGY + Strings.INVALID_OR_CORRUPT_FILE);
        }
      };

      fileReader.readAsText(file);
    }
    else {
      alert(Strings.PLEASE_SELECT_TOPOLOGY_FILE);
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = () => {
    sessionStorage.removeItem("auth");

    devicesToDeleteFromSavedDevices = { devicesToDelete: [] };
    connectionsToDeleteFromSavedConnections = { connectionsToDelete: [] };

    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.refreshLiveListAndScopeDeviceStatus, 5000) });
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalID);
  }

  /*
  Saves the form input to the component state everytime the user
  types something in the form
  */
  handleFormInputChange = (e, { name, value }) => this.setState({ [name]: value })

  handleFormInputSubmit = () => {
    let hasDeviceBeenFound = false;

    // Only verify inputs that are not an empty string
    if (this.state.formInput !== "") {
      // If the input was only whitespaces
      if (/^(\s+)$/.test(this.state.formInput)) {
        alert(Strings.INSERT_VALID_ADDRESS_OR_TAG);
      }
      else {
        // If the user typed a number, try to search by address
        if (!isNaN(this.state.formInput)) {
          let deviceAddress = parseInt(this.state.formInput);

          nodes.forEach((node) => {
            if (deviceAddress === node.id) {
              network.focus(deviceAddress);
              network.selectNodes([deviceAddress]);
              network.fit({
                nodes: [deviceAddress],
                animation: true
              });
              hasDeviceBeenFound = true;
            }
          });

          // If no device with deviceAddress has been found
          if (!hasDeviceBeenFound) {
            alert(Strings.FORM_NO_DEVICE_FOUND_PREFIX + deviceAddress + Strings.FORM_NO_DEVICE_FOUND_SUFFIX);
          }
        }
        // If the user typed something that is not a number, try to search by TAG
        else {
          let foundDeviceIds = [];

          nodes.forEach((node) => {
            let upperCaseFormInput = "";
            let upperCaseNodeLabel = "";

            // if the id is a number we are dealing with a device from live list
            if (!isNaN(node.id)) {
              upperCaseFormInput = this.state.formInput.toUpperCase();
              upperCaseNodeLabel = node.label.toUpperCase();

              if (upperCaseNodeLabel.indexOf(upperCaseFormInput) !== -1) {
                foundDeviceIds.push(node.id);
              }
            }
            // If the id is not a number we are dealing with a device that was
            // added manually by the user, so we search differently
            else {
              let nodeLabel = node.label.split("\n");

              if (nodeLabel[0] !== "") {
                upperCaseFormInput = this.state.formInput.toUpperCase();
                upperCaseNodeLabel = nodeLabel[0].toUpperCase();

                if (upperCaseNodeLabel.indexOf(upperCaseFormInput) !== -1) {
                  foundDeviceIds.push(node.id);
                }
              }
            }
          });

          // If at least one device was found, select it
          if (foundDeviceIds.length > 0) {
            network.selectNodes(foundDeviceIds);
            network.fit({
              nodes: foundDeviceIds,
              animation: true
            });
          }
          else {
            alert(Strings.DEVICE_TAG_NOT_FOUND + this.state.formInput);
          }
        }
      }
    }

  }

  handleHiddenAddressChange = (e, { value }) => {
    let typedNumber = Number(value);

    // Only let the user type integer numbers between the min and max packet values
    if (typedNumber >= 1 && typedNumber <= 127
      && Number.isInteger(typedNumber)) {
      this.setState({ addDeviceAddress: typedNumber });
    }
    else if (typedNumber <= 0) {
      this.setState({ addDeviceAddress: "" });
    }
  }

  addHiddenDevice = () => {
    let typedNumber = Number(this.state.addDeviceAddress);

    // Only let the user insert a device with address between 1 and 127
    if (typedNumber >= 1 && typedNumber <= 127) {
      fetch(Constants.REQUEST_IP_ADDRESS + "addEscravo/" + this.state.addDeviceAddress + "/" + this.state.addDeviceCheckboxValue, { mode: "cors" })
        .then(res => res)
        .then(data => {
          console.log(data);
          alert(Strings.DEVICE_WITH_ADDRESS + typedNumber + Strings.WAS_SUCCESSFULLY_ADDED);
        })
        .catch((error) => {
          console.log(Strings.AN_ERROR_OCURRED + error);
          alert(Strings.DEVICE_WITH_ADDRESS + typedNumber + Strings.IS_ALREADY_IN_NETWORK);
        });
    }
    else {
      alert(Strings.INSERT_VALID_ADDRESS_1_127);
    }
  }

  removeHiddenDevice = () => {
    let typedNumber = Number(this.state.addDeviceAddress);

    // Only let the user try to remove a device with address between 1 and 127
    if (typedNumber >= 1 && typedNumber <= 127) {
      fetch(Constants.REQUEST_IP_ADDRESS + "removeEscravo/" + this.state.addDeviceAddress, { mode: "cors" })
        .then(res => res)
        .then(data => {
          console.log(data);
          alert(Strings.DEVICE_WITH_ADDRESS + typedNumber + Strings.WAS_SUCCESSFULLY_REMOVED);
        })
        .catch((error) => {
          alert(Strings.REMOVE_DEVICE_ERROR + error);
        });
    }
    else {
      alert(Strings.INSERT_VALID_ADDRESS_1_127);
    }
  }

  handleRadioChange = (e, { value }) => this.setState({ addDeviceCheckboxValue: value })

  render() {
    const filter = this.state.formInput;

    return (
      <div>

        <Grid style={gridStyle} columns={3} verticalAlign="middle">

          <Grid.Column textAlign="left" width={4}>
            <Popup position='bottom left' hoverable pinned wide
              trigger={<Icon name="question circle" size="big" color="teal" fitted />}>
              <Popup.Content>
                <Divider horizontal fitted>{Strings.COLORS_LABELS}</Divider>
                <List>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#21ba45" }} />
                    {Strings.LABEL_SLAVE_OK_MASTER_OP}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#ff5722" }} />
                    {Strings.LABEL_MASTER_STOP_CLEAR}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#ffc107" }} />
                    {Strings.LABEL_SLAVE_DIAG}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#f40000" }} />
                    {Strings.LABEL_SLAVE_N_MASTER_FAULT}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#ffb6c1" }} />
                    {Strings.LABEL_SLAVE_CONFIG_ERROR}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#c71585" }} />
                    {Strings.LABEL_SLAVE_PARAM_ERROR}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#add8e6" }} />
                    {Strings.LABEL_SLAVE_ONLINE}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#708090" }} />
                    {Strings.LABEL_SLAVE_MISSING}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#b22222" }} />
                    {Strings.LABEL_SLAVE_MASTER_FAULT}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#000000" }} />
                    {Strings.LABEL_SLAVE_BLACKLIST}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#8b0000" }} />
                    {Strings.LABEL_CRITICAL_SLAVE}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#000080" }} />
                    {Strings.LABEL_MPI}
                  </List.Item>
                  <List.Item>
                    <Icon name="circle" style={{ color: "#38c7bd" }} />
                    {Strings.LABEL_NO_STATUS}
                  </List.Item>
                </List>
              </Popup.Content>
            </Popup >
          </Grid.Column>

          <Grid.Column width={8}>
            <Form onSubmit={this.handleFormInputSubmit} >
              <Form.Input
                id="inputform"
                placeholder={Strings.GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER}
                icon="search"
                name="formInput"
                value={filter}
                onChange={this.handleFormInputChange} />
            </Form>
          </Grid.Column>

          <Grid.Column width={4} />

        </Grid>

        <Grid divided='vertically' doubling stackable >

          <Grid.Row columns={2}>

            <Grid.Column width={12}>
              <div id={NETWORK_ID} style={networkStyle} />
            </Grid.Column>

            <Grid.Column width={4}>
              <Segment>
                <Divider horizontal fitted style={{ marginBottom: "1vh" }}> {Strings.EDIT_EDGE_TYPE} </Divider>

                <Button size="small" compact fluid color="teal" onClick={this.handleEditDefaultConnectionTypeClick}>{Strings.EDIT_TOPOLOGY_POS_STRING}</Button><br />

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>{Strings.POSITION}</Divider>

                <Button size="small" compact fluid color="teal" onClick={this.handleEditNodesPositionClick}>{Strings.EDIT_TOPOLOGY_POS_STRING}</Button><br />
                <Button size="small" compact fluid color="teal" onClick={this.handleSaveNodesPositionClick}>{Strings.SAVE_TOPOLOGY_POS_STRING}</Button><br />
                <Button size="small" compact fluid color="teal" onClick={this.handleDeleteNodesPositionClick}>{Strings.DELETE_TOPOLOGY_POS_STRING}</Button><br />

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>{Strings.EXPORT}</Divider>

                <Button size="small" compact fluid color="teal" onClick={this.exportSvg}>{Strings.EXPORT_SVG}</Button><br />
                <Button size="small" compact fluid color="teal" onClick={this.exportTopology}>{Strings.EXPORT_TOPOLOGY}</Button><br />

                <Divider horizontal fitted style={{ marginBottom: "1vh" }}>{Strings.IMPORT_TOPOLOGY}</Divider>

                <Form onSubmit={this.importTopology}>
                  <Form.Input id="import-topology-input-file" type="file" accept=".json" />
                  <Button size="small" compact fluid color="teal" type="submit" content={Strings.IMPORT} />
                </Form>

              </Segment>

              <Segment id="addDeviceSegment" textAlign="center" style={addDeviceSegmentStyle}>
                <Divider
                  horizontal
                  fitted
                  style={{ marginBottom: "1vh" }}>
                  {Strings.ADD_DEVICE}
                </Divider>
                <Input
                  fluid
                  placeholder={Strings.ADDRESS}
                  value={this.state.addDeviceAddress}
                  type="number"
                  onChange={this.handleHiddenAddressChange} />
                <br />
                <Form widths="equal">
                  <Form.Group inline>
                    <Form.Field >
                      <Checkbox
                        radio
                        label={Strings.MASTER_FAULT_STRING}
                        name="checkboxRadioGroup"
                        value="m"
                        checked={this.state.addDeviceCheckboxValue === "m"}
                        onChange={this.handleRadioChange}
                      />
                    </Form.Field>
                    <Form.Field>
                      <Checkbox
                        radio
                        label={Strings.SLAVE_NAME}
                        name="checkboxRadioGroup"
                        value="e"
                        checked={this.state.addDeviceCheckboxValue === "e"}
                        onChange={this.handleRadioChange}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>

                <Button size="small"
                  compact
                  fluid
                  color="teal"
                  onClick={this.addHiddenDevice}>
                  {Strings.ADD}
                </Button><br />

                <Button
                  size="small"
                  compact
                  fluid
                  color="teal"
                  onClick={this.removeHiddenDevice}>
                  {Strings.REMOVE}
                </Button>

              </Segment>

            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Modal basic size='mini' open={this.state.isAddDeviceModalOpen}>
          <Modal.Header content={Strings.ADD_DEVICE} />
          <Modal.Content>
            <Dropdown
              placeholder={Strings.DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER}
              fluid
              selection
              scrolling
              options={typeOptions}
              onChange={this.onTypeDropdownChange} /><br />

            <Input
              style={tagInputStyle}
              className={ADD_DEVICE_TAG_ID}
              fluid
              id={ADD_DEVICE_TAG_ID}
              placeholder={Strings.TAG_PLACEHOLDER}
              value={this.state.addDeviceTagInputValue}
              onChange={this.onChangeDeviceInput} />

            <Input
              style={scopeIpStyle}
              className={ADD_SCOPE_IP_ID}
              fluid
              id={ADD_SCOPE_IP_ID}
              placeholder="IP"
              value={this.state.addScopeIpInputValue}
              onChange={this.onChangeScopeIpInput} />

          </Modal.Content>
          <Modal.Actions>
            <Button id={ADD_DEVICE_MODAL_CLOSE_ID} color='red'>
              <Icon name='remove' />
              {Strings.CANCEL}
            </Button>
            <Button id={ADD_DEVICE_MODAL_OK_ID} color='green'>
              <Icon name='checkmark' />
              {Strings.ADD}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='mini' open={this.state.isDefaultConnectionTypeModalOpen}>
          <Modal.Header content={Strings.EDIT_EDGE_TYPE} />
          <Modal.Content>
            <Dropdown
              placeholder={Strings.CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER}
              fluid
              selection
              scrolling
              options={connectionsOptions}
              value={this.state.connectionColorType}
              onChange={this.onConnectionDropdownChange} />
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.closeDefaultConnectionTypeModal}>
              <Icon name='remove' />
              {Strings.CANCEL}
            </Button>
            <Button color='green' onClick={this.saveDefaultConnectionType}>
              <Icon name='checkmark' />
              {Strings.EDIT_TOPOLOGY_POS_STRING}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='mini' open={this.state.isEditDeviceModalOpen}>
          <Modal.Header content={Strings.EDIT_DEVICE} />
          <Modal.Content>
            <Input
              fluid
              id={EDIT_DEVICE_TAG_ID}
              placeholder={Strings.TAG_PLACEHOLDER}
              value={this.state.editDeviceTagInputValue}
              onChange={this.onChangeEditDeviceInput} /><br />
          </Modal.Content>
          <Modal.Actions>
            <Button id={EDIT_DEVICE_MODAL_CLOSE_ID} color='red'>
              <Icon name='remove' />
              {Strings.CANCEL}
            </Button>
            <Button id={EDIT_DEVICE_MODAL_OK_ID} color='green'>
              <Icon name='checkmark' />
              {Strings.EDIT_TOPOLOGY_POS_STRING}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='mini' open={this.state.isEditLiveListDeviceModalOpen}>
          <Modal.Header content={Strings.EDIT_DEVICE} />
          <Modal.Content>
            <Dropdown
              placeholder={Strings.DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER}
              fluid
              selection
              scrolling
              options={liveListTypeOptions}
              onChange={this.onTypeDropdownChange} />
          </Modal.Content>
          <Modal.Actions>
            <Button id={EDIT_LL_DEVICE_MODAL_CLOSE_ID} color='red'>
              <Icon name='remove' />
              {Strings.CANCEL}
            </Button>
            <Button id={EDIT_LL_DEVICE_MODAL_OK_ID} color='green'>
              <Icon name='checkmark' />
              {Strings.EDIT_TOPOLOGY_POS_STRING}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='mini' open={this.state.isDeletePositioningModalOpen}>
          <Header icon='trash' content={Strings.REMOVE_POSITIONING} />
          <Modal.Content>
            <p>{Strings.ASK_REMOVE_POSITIONING}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' inverted onClick={this.handleDeleteNodesPositionModalNegativeClick}>{Strings.NO}</Button>
            <Button color='green' inverted onClick={this.handleDeleteNodesPositionModalPositiveClick}>{Strings.YES}</Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const networkStyle = {
  height: "70vh",
  border: "1px solid lightgray",
};

const gridStyle = {
  marginBottom: "-20pt"
};

const addDeviceSegmentStyle = {
  display: "none"
};

const tagInputStyle = {
  display: "none"
};

const scopeIpStyle = {
  display: "none"
};

export default GraphicTopology;